export function inExcludeList(excludeList, objID) {
  objID = objID.toString();
  var index = excludeList.indexOf(objID);
  return index != -1;
}
